/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, {
  useState,
  useEffect,
  Fragment,
  useCallback,
  useRef,
  memo,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ItemsCreators } from '../../../store/actions/items';
import { BotsCreators } from '../../../store/actions/bots';
import { ConnectorsCreators } from '../../../store/actions/connectors';
import * as VoicebotCreators from '../../../store/actions/voice-bots';

import ContextMenuPrimary from '../ContextMenu/ContextMenuPrimary';
import ContextMenuSecondary from '../ContextMenu/ContextMenuSecondary';

import Square from '../Square';

import './index.scss';
import BottomBar from './BottomBar';
import StartPoint from './Components/StartPoint';
import { stopPropagation } from '../../../util/utils';
import BotTest from '../../Chat/BotTest';
import ToastNotification from '../../ToastNotification/ToastNotification';
import { validateSquareInfo } from '../Square/square-validate';
import { changeConnectorsOnError } from '../../../store/actions/bot-creator';
import { emptyTemplateBot } from '../../../store/actions/template-bot';

const Container = (props) => {
  const {
    editItem,
    createItem,
    items,
    allItems,
    setCurrentItem,
    setSelectedMenuOption,
    currentItem,
    currentPath,
    saveViewPosition,
    viewPosition,
    handleDrop,
    currentClickItem,
    showRightMenu,
    showLeftMenu,
    bot,
    onSelectedPathId,
    connectors,
    createConnectorRequest,
    createVoiceConnectorRequest,
    updateSelectedItem,
    testBotVisible,
    user,
    connectorsOnError,
    fetchGrammars,
    fetchStatus,
    fetchVoicebotVariables,
    fetchVoicebotWebApi,
    currentFlow,
    selectedMenuOption,
    triggerGroup,
  } = props;

  const squareClickCallback = {
    Human: () => {
      if (user.selectedCompany?.claim?.name !== 'Viewer') {
        if (bot) {
          const { getQueueAttendance } = props;
          getQueueAttendance({ botId: bot._id, loading: true });
        }
      }
    },
  };

  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);
  const [newItemArrowPoint1, setNewItemArrowPoint1] = useState({ x: 0, y: 0 });
  const [newItemArrowPoint2, setNewItemArrowPoint2] = useState({ x: 0, y: 0 });
  const [showOptionsPrimary, setShowOptionsPrimary] = useState(false);
  const [showOptionsSecondary, setShowOptionsSecondary] = useState(false);
  const [optionsSecondaryVariant, setOptionsSecondaryVariant] =
    useState('defaultItems');
  const [optionsSecondaryPosition, setOptionsSecondaryPosition] = useState({
    top: 0,
    left: 0,
  });
  const [isCreating, setCreating] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(viewPosition.zoomLevel);
  const [isPanning, setPanning] = useState(false);
  const [panOrigin, setPanOrigin] = useState({ x: 0, y: 0 });
  const [panCurrent, setPanCurrent] = useState({
    x: viewPosition.panX,
    y: viewPosition.panY,
  });
  const [draggingItemId, setDraggingItemId] = useState(null);
  const [draggingItemOffset, setDraggingItemOffset] = useState({ x: 0, y: 0 });
  const [hoveredItem, setHoveredItem] = useState(null);
  const [visibleItems, setVisibleItems] = useState({});
  const [menuOptionId, setMenuOptionId] = useState('');
  const [menuOptionLinked, setMenuOptionLinked] = useState({});
  const [wasDragged, setWasDragged] = useState(false);

  useEffect(() => {
    if (
      bot?.type === 'voice' &&
      bot?.voiceSettings &&
      bot?.voicebotInstanceId
    ) {
      const { voicebotInstanceId, voiceSettings } = bot;
      const { codeUser, idProject } = voiceSettings;

      const params = { codeUser, idProject, voicebotInstanceId };
      fetchGrammars({ params });
      fetchStatus({ params });
      fetchVoicebotVariables({ params });
      fetchVoicebotWebApi({ params });
    }
  }, [bot?.type, bot?.voiceSettings, bot?.voicebotInstanceId]);

  useEffect(() => {
    if (items) {
      const buildArea = document
        .querySelector('.builder__zoom-area')
        .getBoundingClientRect();

      const builderWidthZoom = buildArea.width * (1 / zoomLevel);
      const builderHeighWithZoom = buildArea.height * (1 / zoomLevel);

      items.forEach((_item) => {
        const [left, top] = _item.positionOnScreen;

        const OFFSET = 300;
        const leftPosition = left + panCurrent.x;
        const topPosition = top + panCurrent.y;

        const isToRenderOnScreen =
          leftPosition > -OFFSET &&
          leftPosition < builderWidthZoom + OFFSET &&
          topPosition > -OFFSET &&
          topPosition < builderHeighWithZoom + OFFSET;

        if (isToRenderOnScreen) {
          setVisibleItems((oldState) => ({ ...oldState, [_item._id]: _item }));
        } else {
          setVisibleItems((oldState) => ({ ...oldState, [_item._id]: null }));
        }
      });
    }

    return () => setVisibleItems({});
  }, [items, panCurrent, zoomLevel, currentItem]);

  useEffect(() => {
    const timeoutName = 'builder__container--setPanTimeout';

    if (window[timeoutName]) clearTimeout(window[timeoutName]);

    window[timeoutName] = setTimeout(() => {
      saveViewPosition({
        panX: panCurrent.x,
        panY: panCurrent.y,
        zoomLevel,
      });
      window[timeoutName] = null;
    }, 1500);
  }, [panCurrent, zoomLevel]);

  const setInicialGroupPosition = () => {
    setPanCurrent({
      x: 300,
      y: 50,
    });

    setZoomLevel(viewPosition.zoomLevel);
  };

  useEffect(() => {
    setInicialGroupPosition();
  }, [triggerGroup]);

  useEffect(() => {
    return () => {
      const { emptyTemplateBot } = props;
      changeConnectorsOnError([]);
      emptyTemplateBot();
    };
  }, []);

  useEffect(() => {
    if (bot?.type === 'voice') return;

    if (items.length > 0 && connectors.length > 0) {
      const updateConnectorsErrors = [];
      const { changeConnectorsOnError } = props;
      items.forEach((item) => {
        const connectorsItem = connectors.filter(
          (connector) =>
            item._id === connector.from || item._id === connector.to
        );
        const hasSquareValidate = validateSquareInfo.find(
          (square) => square.type === item.type
        );
        if (connectorsItem.length > 0 && hasSquareValidate) {
          const newValidate = hasSquareValidate.validate({
            bot,
            item,
            connectors,
          });
          const newConnectorsOnError = [...connectorsOnError];
          connectorsItem.forEach((element) => {
            const connectorIndex = newConnectorsOnError.indexOf(element);
            if (newValidate) {
              if (connectorIndex > -1) {
                newConnectorsOnError.splice(connectorIndex, 1);
              }
            } else {
              newConnectorsOnError.push(element);
            }
          });
          updateConnectorsErrors.push(...newConnectorsOnError);
        }
      });
      changeConnectorsOnError(updateConnectorsErrors);
    }
  }, [connectors, items, bot?.type]);

  const getMousePos = useCallback(
    (event) => {
      const zoomAreaOffset = document
        .querySelector('.builder__zoom-area')
        .getBoundingClientRect();
      return {
        x: (event.clientX - zoomAreaOffset.x) / zoomLevel,
        y: (event.clientY - zoomAreaOffset.y) / zoomLevel,
      };
    },
    [zoomLevel]
  );

  const mouseMove = useCallback(
    (event) => {
      const pos = getMousePos(event);
      setMouseX(pos.x);
      setMouseY(pos.y);
    },
    [getMousePos]
  );

  const createMenuConnector = () => {
    const isVoicebotConnector = currentItem.type.startsWith('Voice');
    const { id } = currentFlow;

    if (isVoicebotConnector) {
      createVoiceConnectorRequest({
        from: currentClickItem,
        to: hoveredItem._id,
        botId: bot._id,
        voiceSettings: {
          idIvrStepFlow: -1,
          nmIvrResult: currentItem.activeMenuItem.description,
        },
      });
      return;
    }

    createConnectorRequest({
      from: currentItem.activeMenuItem._id,
      to: hoveredItem._id,
      botId: bot._id,
      subflowFor: id !== bot._id ? id : null,
    });
  };

  const createConnectorFromCurrentClickItem = () => {
    const { id } = currentFlow;

    const isVoicebotConnector = currentItem.type.startsWith('Voice');

    if (isVoicebotConnector) {
      let voiceSettings = null;

      const itemsWithFromNextStep = ['VoiceTTSAudio'];
      if (itemsWithFromNextStep.includes(currentItem.type)) {
        voiceSettings = { idIvrStepFlow: -1, nmIvrResult: 'NEXT_STEP' };
      }

      createVoiceConnectorRequest({
        from: currentClickItem,
        to: hoveredItem._id,
        botId: bot._id,
        voiceSettings,
      });
      return;
    }

    createConnectorRequest({
      from: currentClickItem,
      to: hoveredItem._id,
      botId: bot._id,
      subflowFor: id !== bot._id ? id : null,
    });
  };

  const openPrimaryMenu = useCallback(
    (event) => {
      if (!isCreating) return;
      event.preventDefault();

      setNewItemArrowPoint2(getMousePos(event));

      setCreating(false);

      if (hoveredItem && hoveredItem._id !== currentClickItem) {
        const { id } = currentFlow;

        if (currentClickItem) {
          const isMenuItem =
            (currentItem?.type === 'Menu' ||
              currentItem.type === 'MenuAI' ||
              currentItem?.type.startsWith('Voice')) &&
            currentItem?.activeMenuItem;

          if (isMenuItem) {
            createMenuConnector();
          } else {
            createConnectorFromCurrentClickItem();
          }
        } else {
          createConnectorRequest({
            from: currentFlow.id,
            to: hoveredItem._id,
            botId: bot._id,
            subflowFor: id !== bot._id ? id : null,
          });
        }
      } else {
        setShowOptionsPrimary(true);
      }
    },
    [isCreating, hoveredItem, currentClickItem]
  );

  const activateCreate = (event, _item) => {
    event.preventDefault();
    stopPropagation(event);

    setCurrentItem(_item);
    updateSelectedItem(_item);
    setHoveredItem(_item);
    setCreating(true);
    setNewItemArrowPoint1(getMousePos(event));

    setShowOptionsPrimary(false);
    setShowOptionsSecondary(false);
  };

  const onMouseEnter = (event, item) => {
    event.stopPropagation();
    setHoveredItem(item);
  };

  const onMouseLeave = (event, item) => {
    event.stopPropagation();
    setHoveredItem(null);
  };

  const handleContextMenuOption = (e, option) => {
    // console.log('handleContextMenuOption >>>>>>');
    e.preventDefault();
    const halfSquareWidth = 350 / 2; // todo: remove magic number
    const pos = [
      newItemArrowPoint2.x - halfSquareWidth - panCurrent.x,
      newItemArrowPoint2.y - panCurrent.y,
    ];

    e.preventDefault();
    e.stopPropagation();

    const li = e.target.parentElement.parentElement;

    let idx = 0;
    let child = li;
    while ((child = child.previousSibling) != null) idx++;

    const menuRoot = li.parentElement.parentElement.parentElement;

    const contextMenuWidth = li.parentElement.parentElement.clientWidth;
    const left = menuRoot.offsetLeft;
    const top = menuRoot.offsetTop;

    if (
      option.type === 'vtexItems' ||
      option.type === 'ZendeskItems' ||
      option.type === 'JiraItems' ||
      option.type === 'RDStationItems' ||
      option.type === 'GlpiItems'
    ) {
      handleOpenSecondary(option.type, { top, left });
    } else {
      if (!Object.keys(currentItem).length) {
        console.log('IS FROM ROOT!!!');
        option.fromRoot = true;
      } else {
        option.fromRoot = false;
      }

      const menuItems = [
        'Menu',
        'MenuAI',
        'VoiceTTSAudioASR',
        'VoiceTTSAudioDTMF',
        'VoiceSMS',
      ];
      const itemsWithFromNextStep = ['VoiceTTSAudio'];

      if (itemsWithFromNextStep.includes(currentItem.type)) {
        option.from = { _id: currentItem._id, description: 'NEXT_STEP' };
      } else if (menuItems.includes(currentItem.type)) {
        option.from = currentItem.activeMenuItem;
      } else {
        option.from = currentItem;
      }

      createItem(pos, currentItem, option);

      setShowOptionsPrimary(false);
      setShowOptionsSecondary(false);
    }
  };

  const handleOpenSecondary = (variant, position) => {
    setOptionsSecondaryVariant(variant);
    setOptionsSecondaryPosition(position);
    setShowOptionsSecondary(true);
  };

  const panStart = useCallback(
    (event) => {
      const zoomArea = document.querySelector('.builder__zoom-area');

      if (event.target !== zoomArea) return;

      zoomArea.setPointerCapture(event.pointerId);

      setPanOrigin(getMousePos(event));
      setPanning(true);

      event.preventDefault();
    },
    [getMousePos]
  );

  const panStop = useCallback((event) => {
    const zoomArea = document.querySelector('.builder__zoom-area');
    zoomArea.releasePointerCapture(event.pointerId);

    setPanning(false);
  }, []);

  useEffect(() => {
    if (!isPanning) return;
    const dPan = {
      x: mouseX - panOrigin.x,
      y: mouseY - panOrigin.y,
    };
    if (dPan.x === 0 && dPan.y === 0) return;
    setPanCurrent((pan) => ({
      x: pan.x + dPan.x,
      y: pan.y + dPan.y,
    }));
    setPanOrigin({ x: mouseX, y: mouseY });
    setWasDragged(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPanning, panOrigin, mouseX, mouseY]);

  const itemDragStart = useCallback(
    (event) => {
      if (
        event.currentTarget.offsetWidth - event.target.offsetWidth > 5 &&
        event.currentTarget.offsetHeight - event.target.offsetHeight > 5
      )
        return true;
      setDraggingItemId(event.currentTarget.id);
      setDraggingItemOffset(getMousePos(event));
      event.currentTarget.setPointerCapture(event.pointerId);

      return true;
    },
    [getMousePos]
  );

  const itemDragStop = useCallback(
    (event, item) => {
      if (!draggingItemId) return true;
      setDraggingItemId(null);
      event.currentTarget.releasePointerCapture(event.pointerId);

      const { positionOnScreen } = item;
      const [leftPostion, topPosition] = positionOnScreen;

      const offset = {
        x: draggingItemOffset.x - panCurrent.x - leftPostion,
        y: draggingItemOffset.y - panCurrent.y - topPosition,
      };

      const pointer = getMousePos(event);
      const finalPosition = {
        x: pointer.x - panCurrent.x - offset.x,
        y: pointer.y - panCurrent.y - offset.y,
      };

      if (
        Math.abs(finalPosition.x - leftPostion) > 3 ||
        Math.abs(finalPosition.y - topPosition) > 3
      ) {
        editItem({
          ...item,
          positionOnScreen: [finalPosition.x, finalPosition.y],
        });

        setVisibleItems((oldState) => ({
          ...oldState,
          [item._id]: {
            ...item,
            positionOnScreen: [finalPosition.x, finalPosition.y],
          },
        }));
      }
    },
    [draggingItemId, draggingItemOffset, panCurrent]
  );

  const newItemTarget = isCreating
    ? { x: mouseX, y: mouseY }
    : newItemArrowPoint2;
  const newItemArrowComponents = {
    x: newItemTarget.x - newItemArrowPoint1.x,
    y: newItemTarget.y - newItemArrowPoint1.y,
  };
  const newItemArrowLength =
    Math.sqrt(
      Math.pow(newItemArrowComponents.x, 2) +
        Math.pow(newItemArrowComponents.y, 2)
    ) - 5;
  const newItemArrowAngle =
    Math.PI / 2 -
    Math.atan2(newItemArrowComponents.x, newItemArrowComponents.y);

  const resizeAmount = `${(1 / zoomLevel) * 100}%`;
  const translateAmount = `${(1 / zoomLevel - 1) * -50}%`;

  // const svgScaleAmount = 1 / zoomLevel
  // const svgTranslateAmount = (1 / zoomLevel - 1) / 2 * 100 + '%'

  const svgCommand = (command, ...args) =>
    [command, ...args.map((arg) => arg.join(','))].join(' ');

  const builderRoot = useRef();

  const viewBox = [
    -panCurrent.x,
    -panCurrent.y,
    (builderRoot.current && (builderRoot.current.offsetWidth || 0)) /
      zoomLevel || 1,
    (builderRoot.current && (builderRoot.current.offsetHeight || 0)) /
      zoomLevel || 1,
  ];

  useEffect(() => {
    window.requestAnimationFrame(() => {
      setDraggingItemOffset({ x: 0, y: 0 });
    });
  }, []);

  const handleContainerClick = (event) => {
    const zoomMenu = document.getElementById('bottom-bar-zoom-menu');
    zoomMenu.classList.remove('is-zoom-menu-open');
    showLeftMenu(false);

    if (!isCreating && !wasDragged) {
      showRightMenu(undefined, undefined);
      setShowOptionsPrimary(false);
      setShowOptionsSecondary(false);

      if (document.activeElement) {
        const focused = document.getElementById(document.activeElement.id);

        if (focused) {
          focused.blur();
        }
      }

      setCurrentItem(null);
      setSelectedMenuOption(null);
    } else {
      openPrimaryMenu(event);
    }
    setWasDragged(false);
    // openPrimaryMenu(event);
  };

  const handlePathClick = (e, connector) => {
    stopPropagation(e);
    onSelectedPathId(e.target.id);
    updateSelectedItem(null);
    showRightMenu(e, { connector, path: true });
  };

  const handleKeyPress = (e) => {
    // console.log('handleKeyPress', e.keyCode)
  };

  const handleMenuOptionHighLight = (menuId) => {
    setMenuOptionId(menuId);
  };

  useEffect(() => {
    const linkedConnector = connectors.find(
      (connector) => connector.from === menuOptionId
    );
    if (linkedConnector) {
      setMenuOptionLinked(linkedConnector);
    } else {
      setMenuOptionLinked({});
    }
  }, [menuOptionId]);

  /**
   * Executa uma função de callback, caso o bloco tenha que executar uma rotina após ser selecionado
   * @param {Object} item: bloco dentro do criador
   */
  const onSquareClick = (item) => {
    const itemClickCallback = squareClickCallback[item.type];
    if (itemClickCallback) {
      itemClickCallback();
    }
  };

  const openSecondary = (e, item) => {
    e.preventDefault();
    e.stopPropagation();

    const li = e.target.parentElement.parentElement;

    let idx = 0;
    let child = li;
    while ((child = child.previousSibling) != null) idx++;

    const menuRoot = li.parentElement.parentElement.parentElement;

    const contextMenuWidth = li.parentElement.parentElement.clientWidth;

    const left = menuRoot.offsetLeft + contextMenuWidth;
    const top = menuRoot.offsetTop + li.clientHeight * idx;
    handleOpenSecondary(item.value, { top, left });
  };

  const updateScroll = useCallback((event) => {
    if (event.shiftKey || event.ctrlKey) {
      event.preventDefault();
      return false;
    }
  }, []);

  useEffect(() => {
    document.getElementById('root').addEventListener('wheel', updateScroll);
    return () => {
      document
        .getElementById('root')
        .removeEventListener('wheel', updateScroll);
    };
  }, [updateScroll]);

  return (
    <section
      className="builder"
      ref={builderRoot}
      onPointerMove={mouseMove}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => handleDrop(e)}
      onMouseDown={openPrimaryMenu}
      onKeyUp={handleKeyPress}
    >
      {showOptionsPrimary ? (
        <ContextMenuPrimary
          style={{
            top: newItemTarget.y * zoomLevel,
            left: newItemTarget.x * zoomLevel,
          }}
          openSecondary={openSecondary}
          handleOpenSecondary={handleOpenSecondary}
          handleContextMenuOption={handleContextMenuOption}
          botType={bot?.type}
        />
      ) : null}
      {showOptionsSecondary ? (
        <ContextMenuSecondary
          style={{
            top: optionsSecondaryPosition.top,
            left: optionsSecondaryPosition.left,
          }}
          handleContextMenuOption={handleContextMenuOption}
          variant={optionsSecondaryVariant}
          openSecondary={openSecondary}
          handleOpenSecondary={handleOpenSecondary}
        />
      ) : null}
      <div
        id="container-criador"
        onPointerDown={panStart}
        onPointerUp={panStop}
        className="builder__zoom-area"
        style={{
          transform: `scale(${zoomLevel}) translate(${translateAmount},${translateAmount})`,
          height: resizeAmount,
          width: resizeAmount,
          cursor: isCreating
            ? 'pointer'
            : isPanning || draggingItemId
            ? 'grabbing'
            : 'grab',
          backgroundSize: 60 * zoomLevel,
          backgroundPosition: `top ${panCurrent.y}px left ${panCurrent.x}px`,
        }}
        onClick={(event) => handleContainerClick(event)}
      >
        <div>
          {isCreating || showOptionsPrimary ? (
            <div
              className="builder__new-item-dashed-line"
              style={{
                position: 'absolute',
                left: newItemArrowPoint1.x,
                top: newItemArrowPoint1.y,
                width: newItemArrowLength,
                transform: `rotate(${newItemArrowAngle}rad)`,
              }}
            />
          ) : null}
          {/* Ponta da flecha quando está sendo criado um novo item. */}
          {isCreating ? (
            <div
              className="builder__new-item-arrow"
              style={{
                position: 'absolute',
                left: newItemTarget.x - 5,
                top: newItemTarget.y - 5,
                transform: `rotate(${newItemArrowAngle + Math.PI / 4}rad)`,
              }}
            />
          ) : null}

          {/* O <svg> desenha as setas que ligam os blocos. */}
          <svg viewBox={viewBox.join(' ')} className="builder__item-arrows">
            {connectors.length > 0 &&
              items.length > 0 &&
              connectors.map((connector, idx) => {
                const position = (it, el) => {
                  if (it._id === draggingItemId) {
                    return [
                      mouseX -
                        draggingItemOffset.x +
                        it.positionOnScreen[0] +
                        el.offsetWidth / 2,
                      mouseY -
                        draggingItemOffset.y +
                        it.positionOnScreen[1] +
                        el.offsetHeight / 2,
                    ];
                  }
                  return [
                    it.positionOnScreen[0] + el.offsetWidth / 2,
                    it.positionOnScreen[1] + el.offsetHeight / 2,
                  ];
                };

                let ancestor = items.find(
                  (item) => item._id === connector.from
                );
                let menuItem = false;
                // o ancestor não é um item e não é do ponto inicial
                if (!ancestor && connector.from !== bot._id) {
                  menuItem = true;
                  const menus = items.filter(
                    (item) => item.type === 'Menu' || item.type === 'MenuAI'
                  );
                  ancestor = menus.find((menu) =>
                    menu.menuItems.some(
                      (menuItem) => menuItem._id === connector.from
                    )
                  );
                }

                let ancestorElement;

                if (!menuItem) {
                  ancestorElement = ancestor
                    ? document.getElementById(connector.from) || {
                        offsetWidth: 350,
                        offsetHeight: 100,
                      }
                    : document.getElementById('builder__root') || {
                        offsetWidth: 80,
                        offsetHeight: 80,
                      };
                } else {
                  ancestorElement = ancestor
                    ? document.getElementById(ancestor._id) || {
                        offsetWidth: 350,
                        offsetHeight: 100,
                      }
                    : document.getElementById('builder__root') || {
                        offsetWidth: 80,
                        offsetHeight: 80,
                      };
                }

                const itemElement = document.getElementById(connector.to) || {
                  offsetWidth: 350,
                  offsetHeight: 100,
                };

                let ancestorPosition;
                if (ancestor) {
                  ancestorPosition = position(ancestor, ancestorElement);
                } else {
                  ancestorPosition = position(
                    { _id: bot._id, positionOnScreen: [500, 50] },
                    ancestorElement
                  );
                }
                const itemPosition = position(
                  items.filter((item) => item._id === connector.to)[0] || {
                    _id: bot._id,
                    positionOnScreen: [500, 50],
                  },
                  itemElement
                );

                const translate = (pos, el, qdt, ofst = 0) =>
                  [
                    // position,element,quadrant
                    [pos[0] - el.offsetWidth / 2 - ofst, pos[1]],
                    [pos[0], pos[1] - el.offsetHeight / 2 - ofst],
                    [pos[0] + el.offsetWidth / 2 + ofst, pos[1]],
                    [pos[0], pos[1] + el.offsetHeight / 2 + ofst],
                  ][qdt];

                const findAngle = (it1, it2) =>
                  (Math.atan2(it2[1] - it1[1], it2[0] - it1[0]) / Math.PI +
                    1 +
                    1 / 4) %
                  2;

                const findQuadrant = (angle) => Math.floor(angle / 0.5);

                const angle = findAngle(ancestorPosition, itemPosition);
                const quadrant = findQuadrant(angle);
                const source = translate(
                  ancestorPosition,
                  ancestorElement,
                  quadrant
                );

                const target = translate(
                  itemPosition,
                  itemElement,
                  (quadrant + 2) % 4,
                  8
                );
                const arrow = translate(
                  itemPosition,
                  itemElement,
                  (quadrant + 2) % 4
                );

                const vertical = quadrant % 2;

                const ctrl = (mult) => [
                  (target[0] - source[0]) * (mult[vertical] / 8) + source[0],
                  (target[1] - source[1]) * (mult[(vertical + 1) % 2] / 8) +
                    source[1],
                ];

                const commands = [
                  svgCommand('M', ctrl([0, 0])),
                  svgCommand('Q', ctrl([0.5, -0.25]), ctrl([1, 0])),
                  svgCommand('C', ctrl([3, 1]), ctrl([5, 7]), ctrl([7, 8])),
                  svgCommand('Q', ctrl([7.5, 8.25]), ctrl([8, 8])),
                ];

                const rotation = [-90, 0, +90, +180][quadrant];
                const hasError = connectorsOnError.indexOf(connector);
                let color = hasError > -1 ? '#F15F52' : '#CCC';

                if (currentPath?._id === connector._id) {
                  color = hasError > -1 ? '#F15F52' : 'black';
                } else if (
                  menuOptionLinked?._id === connector._id ||
                  (currentClickItem &&
                    (connector.from === currentClickItem ||
                      connector.to === currentClickItem))
                ) {
                  if (currentItem?.menuItems?.length) {
                    const isSelectedOption = currentItem.menuItems.find(
                      (menuItem) =>
                        menuItem._id === selectedMenuOption?.optionId
                    );

                    if (
                      isSelectedOption &&
                      connector?.voiceSettings?.nmIvrResult ===
                        selectedMenuOption?.description
                    ) {
                      color = '#e2d74c';
                    } else if (menuOptionLinked?._id === connector._id) {
                      color = hasError > -1 ? '#F15F52' : 'black';
                    }
                  } else {
                    color = hasError > -1 ? '#F15F52' : 'black';
                  }
                } else {
                  color = hasError > -1 ? '#F15F52' : '#CCC';
                }

                return (
                  <Fragment key={idx}>
                    <path
                      d={commands.join(' ')}
                      stroke={color}
                      strokeWidth="4"
                      className="arrow-path-connector"
                    />
                    <path
                      id={`${connector._id}`}
                      d={commands.join(' ')}
                      fill="none"
                      stroke="transparent"
                      pointerEvents="visibleStroke"
                      onClick={(event) => handlePathClick(event, connector)}
                      strokeWidth="25"
                      style={{ cursor: 'pointer' }}
                    />
                    <polygon
                      points={[
                        [arrow[0] + 0, arrow[1] + 0].join(','),
                        [arrow[0] + 0, arrow[1] + 16].join(','),
                        [arrow[0] + 16, arrow[1] + 0].join(','),
                      ].join(' ')}
                      fill={color}
                      transform={`rotate(${rotation + 45},${arrow.join(',')})`}
                    />
                  </Fragment>
                );
              })}
          </svg>

          <StartPoint
            user={user}
            connectors={connectors}
            botId={bot?._id}
            panCurrent={panCurrent}
            activateCreate={activateCreate}
          />

          {Object.keys(visibleItems).map((key) => {
            const item = visibleItems[key];

            const isVisibleOnScreen = !item;
            if (isVisibleOnScreen) return null;

            if (item.root) {
              return null;
            }

            const offset = {
              x: draggingItemOffset.x - panCurrent.x - item.positionOnScreen[0],
              y: draggingItemOffset.y - panCurrent.y - item.positionOnScreen[1],
            };

            const position =
              key === draggingItemId
                ? [
                    mouseX - panCurrent.x - offset.x,
                    mouseY - panCurrent.y - offset.y,
                  ]
                : item.positionOnScreen;

            const [left, top] = position;

            return (
              <div
                style={{
                  position: 'absolute',
                  left: left + panCurrent.x,
                  top: top + panCurrent.y,
                  ...(draggingItemId === item._id
                    ? {
                        cursor: 'grabbing',
                      }
                    : {}),
                }}
                id={key}
                onPointerDown={(e) =>
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? itemDragStart(e)
                    : ''
                }
                onPointerUp={(e) =>
                  user?.selectedCompany?.claim?.name !== 'Viewer'
                    ? itemDragStop(e, item)
                    : ''
                }
                onClick={(e) => {
                  if (user?.selectedCompany?.claim?.name !== 'Viewer') {
                    onSquareClick(item);
                    showRightMenu(e, item);
                    stopPropagation(e);
                  }
                }}
                key={key}
              >
                <Square
                  item={item}
                  items={allItems}
                  activateCreate={activateCreate}
                  isCreating={isCreating}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                  currentClickItem={currentClickItem}
                  hoveredItem={hoveredItem}
                  zoomLevel={zoomLevel}
                  setInicialGroupPosition={setInicialGroupPosition}
                  handleMenuOptionHighLight={handleMenuOptionHighLight}
                  menuOptionLinked={menuOptionLinked}
                  currentPath={currentPath}
                  {...props}
                />
              </div>
            );
          })}
        </div>
      </div>
      {/* BOTTOM BAR */}
      <BottomBar
        items={items}
        zoomLevel={zoomLevel}
        setZoomLevel={setZoomLevel}
        setPanCurrent={setPanCurrent}
        showRightMenu={showRightMenu}
        setInicialGroupPosition={setInicialGroupPosition}
        hoveredItem={hoveredItem}
      />
      {/* REMOVE > UNDONE */}
      <ToastNotification />

      {bot && bot.type !== 'voice' && (
        <BotTest showTest={testBotVisible} botId={bot._id} />
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  items: state.items.list,
  currentFlow: state.items.currentFlow,
  connectors: state.connectors.list,
  bot: state.bots.bot,
  currentItem: state.items.currentItem,
  currentClickItem: state.items.currentClickItem,
  selectedMenuOption: state.items.selectedMenuOption,
  testBotVisible: state.previewBot.visible,
  currentPath: state.items.currentPath,
  user: state.users.signedUser,
  connectorsOnError: state.botCreator.connectorsOnError,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...ItemsCreators,
      ...ConnectorsCreators,
      ...BotsCreators,
      ...VoicebotCreators,
      changeConnectorsOnError,
      emptyTemplateBot,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(memo(Container));
